import { IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';

import { IAction } from '@r1-frontend/shared/types/Redux';

import { ECitySelect } from './index';

export type TSetSelectedRegion = IAction<ECitySelect.SET_SELECTED_REGION, IRegionWithCities | null>

const setSelectedRegion = (region: IRegionWithCities | null): TSetSelectedRegion => ({
    type: ECitySelect.SET_SELECTED_REGION,
    payload: region,
});

export default setSelectedRegion;
